const PURPOSE_LABELS = {
    both_id_and_auth: 'ID & Employment Authorization',
    id: 'Identity Document',
    employment_auth: 'Employment Authorization',
    employment_auth_primary: 'Employment Authorization',
    employment_auth_extension: 'Employment Authorization Extension',
    us_photo_id: 'US Photo ID',
}

const DocumentConfirmationDialog = ({ isOpen, onConfirm, onCancel, userTypeLabel, documentSteps, note }) => {
    if (!isOpen) return null

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 space-y-5">

                <div className="space-y-1">
                    <h2 className="text-xl font-bold text-gray-800">Ready to Continue?</h2>
                    <p className="text-sm text-gray-600">
                        Please confirm you have all required documents ready before proceeding.
                    </p>
                </div>

                <div className="bg-blue-50 rounded-xl p-4 space-y-1">
                    <p className="text-sm text-blue-600 font-semibold uppercase tracking-wide">Your Selected Status</p>
                    <p className="text-sm font-medium text-blue-900">{userTypeLabel}</p>
                </div>

                {note && (
                    <div className="bg-amber-50 border border-amber-200 rounded-lg px-3 py-2">
                        <p className="text-sm text-amber-700">{note}</p>
                    </div>
                )}

                <div className="space-y-2">
                    <p className="text-sm font-semibold text-gray-800">Required Documents:</p>
                    <ul className="space-y-2">
                        {documentSteps.map((step, i) => (
                            <li key={i} className="flex items-start gap-3 bg-gray-50 rounded-lg px-3 py-2.5">
                                <div className="mt-0.5 w-5 h-5 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center flex-shrink-0 text-xs font-bold">
                                    {i + 1}
                                </div>
                                <div>
                                    <p className="text-sm text-gray-600 mb-0.5">
                                        {PURPOSE_LABELS[step.purpose] ?? step.purpose}
                                        {step.optional && (
                                            <span className="ml-1 text-gray-600 font-normal">(optional)</span>
                                        )}
                                    </p>
                                    <p className="text-sm text-gray-800 font-medium">{step.label}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-2">
                    <p className="text-sm text-yellow-800">
                        <strong>Important:</strong> Please have these documents physically available before continuing. You will be asked to photograph or upload them during this process.
                    </p>
                </div>

                <div className="flex gap-3 pt-1">
                    <button
                        onClick={onCancel}
                        className="flex-1 px-4 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-medium text-sm hover:bg-gray-50 transition-all focus:outline-none"
                    >
                        Go Back
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 px-4 py-2.5 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold text-sm transition-all focus:outline-none"
                    >
                        Yes, I'm Ready
                    </button>
                </div>

            </div>
        </div>
    )
}

export default DocumentConfirmationDialog
